import { render } from "./module1.vue?vue&type=template&id=c9244484&scoped=true&ts=true"
import script from "./module1.vue?vue&type=script&lang=ts"
export * from "./module1.vue?vue&type=script&lang=ts"

import "./module1.vue?vue&type=style&index=0&id=c9244484&lang=less&scoped=true"

import exportComponent from "/Users/julianzeng/Desktop/Buz/mainland/fuwangleyou-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9244484"]])

export default __exports__